/**
 * Creates a dataLayer push to GTM with event detail, based if
 * cookies has been accepted
 * @param {String} event - event to send
 * @param {Object} detail - object with details to send
 */
export const dataLayerPush = (event, detail) => {
    if ( !window.dataLayer ) {
        return;
    }

    const cookiesAccepted = localStorage.getItem( 'cookies-accepted' );

    if ( cookiesAccepted && cookiesAccepted === 'true' ) {
        window.dataLayer.push( {
            event,
            detail
        } );
    }
};